export default {
  base_url: '',
  routes: {
    api_media_get_media: {
      tokens: [['text', '/media/medias/list']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_get_live_pagination: {
      tokens: [['text', '/lives/Lives-pagination-grape']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_templateDisplay_post_screen_shot_html: {
      tokens: [['text', '/templateDisplay/screen-shot-html']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_screenDisplay_get_screen: {
      tokens: [['text', '/screenDisplay/get-one/']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_templateDisplay_get_template: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/templateDisplay/get-one-template']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_programDisplay_get_params_display: {
      tokens: [['text', '/programDisplay/params-display']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_screenDisplay_post_add_edit_screen: {
      tokens: [['text', '/screenDisplay/add-edit']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_get_list_playlists_pagination: {
      tokens: [['text', '/playlist/list-pagination']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },

    api_templateDisplay_post_add_edit_template: {
      tokens: [['text', '/templateDisplay/add-edit-template']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_bloc_post_thumb: {
      tokens: [['text', '/bloc/upload/thumb']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_bloc_get_images_stored: {
      tokens: [['text', '/video-api/bloc/stored/images']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_screenDisplay_get_existant_screen: {
      tokens: [['text', '/screenDisplay/screen-existance']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_screenDisplay_check_existence_disposition: {
      tokens: [['text', '/screenDisplay/disposition-existence']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_screenDisplay_get_all_disposition: {
      tokens: [['text', '/screenDisplay/list-dispositions']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_screenDisplay_edit_title_disposition: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/screenDisplay/edit-title-disposition']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_screenDisplay_post_edit_screen: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/screenDisplay/edit-screen-title']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_templateDisplay_get_templates_by_rmbox: {
      tokens: [
        ['variable', '/', '[^/]++', 'idRmbox'],
        ['text', '/templateDisplay/templates-by-rmbox'],
      ],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_templateDisplay_get_templates_by_program: {
      tokens: [
        ['variable', '/', '[^/]++', 'idProgram'],
        ['text', '/templateDisplay/templates-by-program'],
      ],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_segmentDisplay_post_add_segment: {
      tokens: [['text', '/segmentDisplay/add']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_segmentDisplay_get_list_segments: {
      tokens: [['text', '/segmentDisplay/list-segments']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_segmentDisplay_post_edit_title_segment: {
      tokens: [['variable', '/', 'd+', 'id'], ['text', '/segmentDisplay/edit-segment-title']],
      defaults: [],
      requirements: {
        id: 'd+',
      },
      hosttokens: [],
    },
    api_log: {
      tokens: [['text', '/global/log']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_templateDisplay_get_template_urls: {
      tokens: [['variable', '/', 'd+', 'id'], ['text', '/templateDisplay/get-template-urls']],
      defaults: [],
      requirements: {
        id: 'd+',
      },
      hosttokens: [],
    },
    api_media_get_contributors: {
      tokens: [['text', '/video/videos/contributors/list']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_parameters_get_themes: {
      tokens: [['text', '/theme']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_segmentDisplay_delete_one: {
      tokens: [['variable', '/', 'd+', 'id'], ['text', '/segmentDisplay/delete-segment']],
      defaults: [],
      requirements: {
        id: 'd+',
      },
      hosttokens: [],
    },
    api_segmentDisplay_post_duplicate_segment: {
      tokens: [['variable', '/', 'd+', 'id'], ['text', '/segmentDisplay/duplicate-segment']],
      defaults: [],
      requirements: {
        id: 'd+',
      },
      hosttokens: [],
    },
    api_parameters_get_themes_children_per_canal: {
      tokens: [['text', '/theme/themes-children-per-canal']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_segmentDisplay_get_one_segments: {
      tokens: [['variable', '/', 'd+', 'id'], ['text', '/segmentDisplay/one-segment']],
      defaults: [],
      requirements: {
        id: 'd+',
      },
      hosttokens: [],
    },

    /*Todo add api routing playlist*/
  },
  prefix: '',
  host: 'localhost',
  scheme: 'http',
};



// WEBPACK FOOTER //
// ./src/core/router/fos_js_routes_export.js